import React, { createContext, useContext } from "react";
import { useCoverageDisplayItems } from "@/shared/hooks/useCoverageDisplayItems";
import { CoverageSettings, Pet } from "@/shared/types/Quote.interface";

interface CoverageDisplayProviderProps {
    children: React.ReactNode;
    coverageInfo?: CoverageSettings;
    species?: Pet["species"];
    samplePolicyUrl: string;
    isDentalCovered?: boolean;
    isMicrochippingCovered?: boolean;
    showBreedSpecificConditions?: boolean;
}

type CoverageDisplayContextType = ReturnType<typeof useCoverageDisplayItems>;

const CoverageDisplayContext = createContext<CoverageDisplayContextType | undefined>(undefined);

export const CoverageDisplayProvider: React.FC<CoverageDisplayProviderProps> = ({ children, ...props }) => {
    const displayItems = useCoverageDisplayItems(props);
    return <CoverageDisplayContext.Provider value={displayItems}>{children}</CoverageDisplayContext.Provider>;
};

export const useCoverageDisplayContext = () => {
    const context = useContext(CoverageDisplayContext);
    if (!context) {
        throw new Error("useCoverageDisplayContext must be used within a CoverageDisplayProvider");
    }
    return context;
};
